// extracted by mini-css-extract-plugin
export default {"title":"AllCourses_title__hRn2I","description":"AllCourses_description__p8rUg","button":"AllCourses_button__G9LQK"};